class LoadMorePagination {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('pagination__load-more')) {
        e.preventDefault();
        this.loadMore(e.target);
      }
    });
  }

  async loadMore(button) {
    const url = button.getAttribute('href');
    if (!url) return;

    // Disable button during loading
    button.classList.add('loading');
    button.textContent = 'Loading...';
    button.style.pointerEvents = 'none';

    try {
      const response = await fetch(url);
      const html = await response.text();

      // Parse the HTML response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get the product grid from the response
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      const currentGrid = document.querySelector('#product-grid');

      if (newProducts && currentGrid) {
        // Append new products to the existing grid
        newProducts.forEach((product) => {
          currentGrid.appendChild(product.cloneNode(true));
        });
      }

      // Update the URL without reloading the page
      window.history.pushState({}, '', url);

      // Update or remove the load more button
      const newPagination = doc.querySelector('.pagination__load-more');
      const currentPaginationWrapper = document.querySelector('.pagination-wrapper');

      if (newPagination && currentPaginationWrapper) {
        // Update the button with the new URL
        button.setAttribute('href', newPagination.getAttribute('href'));
        button.classList.remove('loading');
        button.textContent = 'Load More';
        button.style.pointerEvents = 'auto';
      } else {
        // No more pages - replace button with end message
        const paginationNav = document.querySelector('.pagination');
        if (paginationNav) {
          paginationNav.innerHTML = '<div class="pagination__end-message">No more items to load</div>';
        }
      }

      // Reinitialize any scripts that might be needed for new products
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }

    } catch (error) {
      console.error('Error loading more products:', error);
      button.classList.remove('loading');
      button.textContent = 'Load More';
      button.style.pointerEvents = 'auto';
      alert('Failed to load more products. Please try again.');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LoadMorePagination();
  });
} else {
  new LoadMorePagination();
}
